import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';
import {
  FloatingLabelInput as Input,
  SelectableBlock
} from '../../../Elements';
import NumberFormat from 'react-number-format';
import currencyFormatter from 'currency-formatter';
import { produce } from 'immer';
import Formsy from 'formsy-react';
import styles from '../Invoice.scss';

class EnterAmount extends Component {
  static propTypes = {
    onRefundTypeSelect: PropTypes.func.isRequired,
    invoice: PropTypes.object.isRequired,
    payment: PropTypes.object.isRequired,
    refundType: PropTypes.string,
    submitted: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.state = {
      refund: {}
    };
    this.fieldChange = this.fieldChange.bind(this);
    this.textFieldChange = this.textFieldChange.bind(this);
    this.getInvoiceTotal = this.getInvoiceTotal.bind(this);
    this.getTotalRefunds = this.getTotalRefunds.bind(this);
    this.getTotalPaid = this.getTotalPaid.bind(this);
    this.maxRefund = this.maxRefund.bind(this);
  }

  componentWillMount() {
    Formsy.addValidationRule(
      'isPositive',
      (values, value) => Number(value) > 0
    );
    Formsy.addValidationRule(
      'isUnderMaxRefund',
      (values, value) => Number(value) <= this.maxRefund() / 100
    );
  }

  getInvoiceTotal() {
    return this.props.invoice.invoice_line_items.edges.reduce(
      (total, { node: lineItem }) =>
        total + (lineItem.quantity || 1) * (lineItem.price_cents || 0) / 100,
      0
    );
  }

  getTotalRefunds() {
    return this.props.invoice.payments.edges.reduce(
      (totalRefunds, { node: payment }) =>
        totalRefunds +
        payment.refunds.edges.reduce(
          (paymentRefunds, { node: refund }) => refund.amount_cents / 100,
          0
        ),
      0
    );
  }

  getTotalPaid() {
    return this.props.invoice.payments.edges.reduce(
      (total, { node: payment }) => total + payment.amount_cents / 100,
      0
    );
  }

  maxRefund() {
    const refundedCents = this.props.payment.refunds.edges.reduce(
      (total, paymentRefund) => total + paymentRefund.node.amount_cents,
      0
    );
    return this.props.payment.amount_cents - refundedCents;
  }

  fieldChange(key, value) {
    this.setState(
      produce(draft => {
        /* eslint-disable no-param-reassign */
        draft.refund[key] = value;
      })
    );
  }

  textFieldChange(e) {
    this.fieldChange(e.target.name, e.target.value);
  }

  render() {
    const { onRefundTypeSelect, payment, refundType, submitted } = this.props;
    const { refund } = this.state;
    return (
      <Grid padded relaxed stackable centered>
        <Grid.Row>
          <Grid.Column>
            <SelectableBlock
              name='refundType'
              value='full'
              radio
              onChange={onRefundTypeSelect}
              checked={refundType === 'full'}
              style={{ margin: '2em 0' }}
            >
              <div style={{ display: 'flex' }}>
                <div style={{ flex: 1 }}>
                  <h4>Full Refund</h4>
                </div>
                <div style={{ textAlign: 'right' }}>
                  {currencyFormatter.format(this.maxRefund() / 100, {
                    code: payment.amount_currency
                  })}
                </div>
              </div>
            </SelectableBlock>
            <SelectableBlock
              name='refundType'
              value='partial'
              radio
              onChange={onRefundTypeSelect}
              checked={refundType === 'partial'}
            >
              <div style={{ display: 'flex' }}>
                <div style={{ flex: 1 }}>
                  <h4>Partial Refund</h4>
                  <p className={styles.paymentAmountDescription}>
                    You can refund any amount up to{' '}
                    {currencyFormatter.format(this.maxRefund() / 100, {
                      code: payment.amount_currency
                    })}
                  </p>
                </div>
                <div style={{ textAlign: 'right' }}>
                  {refundType === 'partial' &&
                    <Input
                      name='amount'
                      autoFocus
                      className={styles.rightAlignedField}
                      type='currency'
                      value={refund.amount || ''}
                      onChange={this.textFieldChange}
                      submitted={submitted}
                      placeholder='$100.00'
                      validations={{
                        isPositive: null,
                        isUnderMaxRefund: null
                      }}
                      required={refundType === 'partial'}
                      validationError='Required'
                      validationErrors={{
                        isPositive: 'Must be a positive number',
                        isUnderMaxRefund: `Cannot refund more than ${currencyFormatter.format(
                          this.maxRefund() / 100,
                          {
                            code: payment.amount_currency
                          }
                        )}`
                      }}
                    >
                      <NumberFormat
                        thousandSeparator
                        prefix={'$'}
                        decimalScale={2}
                        fixedDecimalScale
                      />
                    </Input>}
                </div>
              </div>
            </SelectableBlock>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row columns='equal'>
          <Grid.Column>
            <Input
              name='notes'
              label='Refund Notes'
              value={refund.notes || ''}
              onChange={this.textFieldChange}
              submitted={submitted}
              autoHeight
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default EnterAmount;



// WEBPACK FOOTER //
// ./webpack/components/Document/Invoice/Refund/EnterAmount.js